import i18n from 'i18n';

const PAGINATION_ROWS = [10, 25, 50, 100];

const mainColumnHeaders = {
  rateNumber: i18n.t('rateNumber', { ns: 'rates' }),
  shippingLine: i18n.t('shipowner', { ns: 'rates' }),
  startPort: i18n.t('routeFrom', { ns: 'rates' }),
  endPort: i18n.t('routeTo', { ns: 'rates' }),
  containerType: i18n.t('containerType', { ns: 'rates' }),
  rateAllIn: i18n.t('rateAllIn', { ns: 'rates' }),
  dateFrom: i18n.t('dateFrom', { ns: 'rates' }),
  dateTo: i18n.t('dateTo', { ns: 'rates' }),
  publicationDate: i18n.t('publicationDate', { ns: 'rates' }),
};

const collapsedColumnHeaders = {
  contractNumber: i18n.t('contractNumber', { ns: 'rates' }),
  tradeType: i18n.t('tradeType', { ns: 'rates' }),
  commodities: i18n.t('commodity', { ns: 'rates' }),
  namedAccounts: i18n.t('namedAccount', { ns: 'rates' }),
  region: i18n.t('region', { ns: 'rates' }),
  stormRateJobs: i18n.t('activities', { ns: 'rates' }),
  daysOff: i18n.t('daysOff', { ns: 'rates' }),
  note: i18n.t('internalNote', { ns: 'rates' }),
};

const MAIN_HEADERS = Object.entries(mainColumnHeaders);
const COLLAPSED_HEADERS = Object.entries(collapsedColumnHeaders);

const STATUS_LABEL = i18n.t('status', { ns: 'rates' });

const ALL_LABEL = i18n.t('all', { ns: 'rates' });
const EXPORT = i18n.t('tradeTypeLabels.EXPORT', { ns: 'activity' });
const IMPORT = i18n.t('tradeTypeLabels.IMPORT', { ns: 'activity' });

const PUBLISHED_LABEL = i18n.t('published', { ns: 'rates' });
const DRAFT_LABEL = i18n.t('draft', { ns: 'rates' });

const ONLY_MINE_LABEL = i18n.t('onlyMine', { ns: 'rates' });
const PUBLICATION_DATE_FROM_LABEL = i18n.t('publicationDateFrom', {
  ns: 'rates',
});
const PUBLICATION_DATE_TO_LABEL = i18n.t('publicationDateTo', {
  ns: 'rates',
});

const NULL_VALUE = i18n.t('null', { ns: 'rates' });

export {
  PUBLISHED_LABEL,
  DRAFT_LABEL,
  mainColumnHeaders,
  collapsedColumnHeaders,
  MAIN_HEADERS,
  COLLAPSED_HEADERS,
  PAGINATION_ROWS,
  STATUS_LABEL,
  EXPORT,
  IMPORT,
  ONLY_MINE_LABEL,
  ALL_LABEL,
  PUBLICATION_DATE_FROM_LABEL,
  PUBLICATION_DATE_TO_LABEL,
  NULL_VALUE,
};
